import React from "react";

import { BaseTips } from "./BaseTips";
import { TipsContainer } from "./Container";

export const Tips: React.FC = () => (
  <TipsContainer>
    <BaseTips />
  </TipsContainer>
);
